export enum TuRRoleType {
  TR_ADMIN = 'tr-admin',
  TR_FN = 'tr-fn',
  TR_MANAGER = 'tr-manager',
  TR_SERVICE = 'tr-service',
  TR_EMPLOYEE = 'tr-employee',
  TR_CONTENT = 'tr-content',
}
